import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@baditaflorin/mesh-common/styles.css";
import "./styles.css";
import { App } from "./App";

const root = document.getElementById("root");
if (!root) throw new Error("Root element is missing");

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
